import Navbar from "../components/Navbar";
import Resources from "../components/Resources";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function ResourcesPage() {
    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="resources-page" className="pt-[7rem]">
                <Resources />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
